module.exports = __webpack_public_path__ + "static/media/genial-logo.c2d46d60.png";